module.exports = __webpack_public_path__ + "f5160d563e656170f8b572dafc19a240.png";